import { render, staticRenderFns } from "./CampaignsList.vue?vue&type=template&id=9579aa20&scoped=true"
import script from "./CampaignsList.vue?vue&type=script&lang=js"
export * from "./CampaignsList.vue?vue&type=script&lang=js"
import style0 from "./CampaignsList.vue?vue&type=style&index=0&id=9579aa20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9579aa20",
  null
  
)

export default component.exports